import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import AdminLayout from "./components/AdminLayout";
import { Toaster } from "./components/ui/toaster";
import { AdminProvider } from "./contexts/AdminContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Employers from "./pages/Employers";
import Resources from "./pages/Resources";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminServices from "./pages/admin/AdminServices";
import AdminNews from "./pages/admin/AdminNews";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminContent from "./pages/admin/AdminContent";
import AdminFAQ from "./pages/admin/AdminFAQ";
import AdminEmployerInfo from "./pages/admin/AdminEmployerInfo";
import AdminOtherServices from "./pages/admin/AdminOtherServices";
import AdminContactPage from "./pages/admin/AdminContactPage";
import AdminResources from "./pages/admin/AdminResources";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AdminProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={
                <>
                  <Navbar />
                  <Home />
                  <Footer />
                  <FloatingWhatsApp />
                </>
              } />
              <Route path="/about" element={
                <>
                  <Navbar />
                  <About />
                  <Footer />
                  <FloatingWhatsApp />
                </>
              } />
              <Route path="/services" element={
                <>
                  <Navbar />
                  <Services />
                  <Footer />
                  <FloatingWhatsApp />
                </>
              } />
              <Route path="/employers" element={
                <>
                  <Navbar />
                  <Employers />
                  <Footer />
                  <FloatingWhatsApp />
                </>
              } />
              <Route path="/resources" element={
                <>
                  <Navbar />
                  <Resources />
                  <Footer />
                  <FloatingWhatsApp />
                </>
              } />
              <Route path="/faq" element={
                <>
                  <Navbar />
                  <FAQ />
                  <Footer />
                  <FloatingWhatsApp />
                </>
              } />
              <Route path="/contact" element={
                <>
                  <Navbar />
                  <Contact />
                  <Footer />
                  <FloatingWhatsApp />
                </>
              } />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="services" element={<AdminServices />} />
                <Route path="other-services" element={<AdminOtherServices />} />
                <Route path="contact-page" element={<AdminContactPage />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="resources" element={<AdminResources />} />
                <Route path="faq" element={<AdminFAQ />} />
                <Route path="employer-info" element={<AdminEmployerInfo />} />
                <Route path="news" element={<AdminNews />} />
                <Route path="contacts" element={<AdminContacts />} />
              </Route>
            </Routes>
            <Toaster />
          </BrowserRouter>
        </AdminProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
